<template>
  <div class="container">
    <head-component/>
    <UserStatsCardsComponent/>
    <div class="row my-5">
      <div class="col-12 col-md-6 mb-3">
        <UserOsChartComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <UserWebChartComponent class="my-3"/>
      </div>

    </div>
    <div class="row my-5">
      <div class="col-12 col-md-4 mb-3">
        <UserTopIpsComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <UserTopCountriesComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <UserTopCitiesComponent class="my-3"/>
      </div>

    </div>
    <div v-if="loading" class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <footer-component/>
  </div>
</template>

<script>

  import { defineComponent } from 'vue';

  import HeadComponent from "@/components/views/head/HeadComponent.vue";
  import FooterComponent from "@/components/views/footer/FooterComponent.vue";
  import UserStatsCardsComponent from "@/components/views/stastistics/userStatistics/UserStatsCardsComponent.vue";
  import UserOsChartComponent from "@/components/views/stastistics/userStatistics/UserOsChartComponent.vue";
  import UserWebChartComponent from "@/components/views/stastistics/userStatistics/UserWebChartComponent.vue";
  import UserTopIpsComponent from "@/components/views/stastistics/userStatistics/UserTopIpsComponent.vue";
  import UserTopCountriesComponent from "@/components/views/stastistics/userStatistics/UserTopCountriesComponent.vue";
  import UserTopCitiesComponent from "@/components/views/stastistics/userStatistics/UserTopCitiesComponent.vue";

  export default defineComponent({
  name: "UserStatisticsComponent",
  /**
   * Represents the collection of reusable components that are part of a larger application.
   * Each component serves a specific purpose and contributes to the functionality or UI of the application.
   *
   * @property {Object} FooterComponent - The footer section component of the application.
   * @property {Object} HeadComponent - The head section or metadata component of the application.
   * @property {Object} UserStatsCardsComponent - A component displaying statistical cards related to user data.
   * @property {Object} UserOsChartComponent - A component visualizing user operating system data in a chart format.
   * @property {Object} UserWebChartComponent - A component visualizing user web-related data in a chart format.
   * @property {Object} UserTopIpsComponent - A component displaying the list of top user IPs.
   * @property {Object} UserTopCountriesComponent - A component displaying information about the top countries represented in user data.
   * @property {Object} UserTopCitiesComponent - A component displaying information about the top cities represented in user data.
   */
  components: {
  FooterComponent,
  HeadComponent,
  UserStatsCardsComponent,
  UserOsChartComponent,
  UserWebChartComponent,
  UserTopIpsComponent,
  UserTopCountriesComponent,
  UserTopCitiesComponent
}
});
</script>

